/*==================================================
=                 UTILITAS WHO
==================================================*/

function calculateZScore(value, ref) {

    const L =
        Number(ref.L);

    const M =
        Number(ref.M);

    const S =
        Number(ref.S);

    if (L === 0) {

        return (
            Math.log(value / M) /
            S
        );

    }

    return (
        Math.pow(
            value / M,
            L
        ) - 1
    ) / (L * S);

}

function zToPercentile(z) {

    const t =
        1 /
        (
            1 +
            0.2316419 *
            Math.abs(z)
        );

    const d =
        0.3989423 *
        Math.exp(
            -z * z / 2
        );

    let p =
        d *
        t *
        (
            0.3193815 +
            t *
            (
                -0.3565638 +
                t *
                (
                    1.781478 +
                    t *
                    (
                        -1.821256 +
                        t *
                        1.330274
                    )
                )
            )
        );

    if (z > 0) {
        p = 1 - p;
    }

    return p * 100;

}

function clamp(
    value,
    min,
    max
) {

    return Math.min(
        Math.max(
            value,
            min
        ),
        max
    );

}

function classifyAdultBMI(bmi) {

    if (bmi < 18.5) {

        return {
            category:
                "Berat Badan Kurang",

            advice:
                "Berat badan Anda berada di bawah rentang ideal. Pertimbangkan untuk meningkatkan asupan kalori dan protein secara bertahap."
        };

    }

    if (bmi < 25) {

        return {
            category:
                "Berat Badan Ideal",

            advice:
                "BMI Anda berada dalam rentang ideal. Pertahankan pola makan seimbang dan aktivitas fisik secara rutin."
        };

    }

    if (bmi < 30) {

        return {
            category:
                "Kelebihan Berat Badan",

            advice:
                "Pola makan seimbang dan olahraga teratur dapat membantu meningkatkan kesehatan Anda."
        };

    }

    return {
        category:
            "Obesitas",

        advice:
            "Pertimbangkan untuk berkonsultasi dengan dokter atau tenaga kesehatan."
    };

}

function classifyChildBMI(z) {

    if (z < -3) {

        return {
            category:
                "Sangat Kurus",

            advice:
                "Hasil berada jauh di bawah rentang sehat WHO. Konsultasikan dengan dokter anak."
        };

    }

    if (z < -2) {

        return {
            category:
                "Kurus",

            advice:
                "Hasil berada di bawah rentang sehat WHO."
        };

    }

    if (z <= 1) {

        return {
            category:
                "Berat Badan Ideal",

            advice:
                "BMI menurut usia berada dalam rentang sehat WHO."
        };

    }

    if (z <= 2) {

        return {
            category:
                "Berisiko Kelebihan Berat Badan",

            advice:
                "Pantau pola makan dan aktivitas fisik anak secara berkala."
        };

    }

    if (z <= 3) {

        return {
            category:
                "Kelebihan Berat Badan",

            advice:
                "Hasil berada di atas rentang sehat WHO."
        };

    }

    return {
        category:
            "Obesitas",

        advice:
            "Konsultasikan hasil ini dengan dokter atau tenaga kesehatan."
    };

}